export default "__VITE_ASSET__DuUUVf83__"